<template>
  <div class="base">
    <account-header jump-user-type="user" />
    <div class="main">
      <div class="panel">
        <div>
          <div class="panno" />
        </div>
        <div class="title">
          <span>家长找回密码</span>
        </div>
        <div style="margin-top: 40px;text-align: left">
          <a-alert message="将发送验证码到你绑定的手机" type="info" show-icon />
        </div>
        <div class="form-panel">
          <div class="form-panel">
            <a-form :form="form" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" @submit="handleSubmit">
              <a-alert v-if="retrieveError" type="error" show-icon style="margin-bottom: 24px;"
                :message="retrieveErrorMessage" />
              <a-form-item>
                <a-input v-decorator="[
                  'username',
                  { rules: [{ required: true, message: '请输入昵称' }] }
                ]" size="large" placeholder="用户名" />
              </a-form-item>
              <a-form-item>
                <a-input v-decorator="[
                  'phone',
                  { rules: [{ required: true, message: '请输入手机号' }] }
                ]" type="text" size="large" placeholder="绑定的手机" />
              </a-form-item>
              <a-form-item v-if="false">
                <a-row :gutter="16">
                  <a-col :span="16">
                    <a-input v-decorator="[
                      'captcha_value',
                      {
                        rules: [
                          { required: true, message: '请输入图形验证码' },
                          { min: 4, message: '验证码长度不小于4个字符' }
                        ]
                      }
                    ]" size="large" placeholder="图形验证码" />
                  </a-col>
                  <a-col :span="8">
                    <img style="cursor: pointer" width="80px" height="100%" :src="captcha_img_str" alt=""
                      @click="loadVerify">
                  </a-col>
                </a-row>
              </a-form-item>
              <a-form-item>
                <a-input v-decorator="[
                  'phone_captcha_code',
                  {
                    rules: [
                      { required: true, message: '请输入短信验证码' },
                      { min: 4, message: '验证码长度不小于4个字符' }
                    ]
                  }
                ]" size="large" placeholder="手机验证码" />
                <a-button :disabled="state.getCodeBtn" type="link" class="get-code-btn" size="large"
                  @click="handleGetPhoneCode">
                  {{ lastTimeContent }}
                </a-button>
              </a-form-item>
              <a-form-item>
                <a-button :loading="state.retrieveBtn" :disabled="state.retrieveBtn" size="large" type="primary"
                  html-type="submit" block>
                  验证
                </a-button>
              </a-form-item>
            </a-form>
          </div>
          <div class="relevant">
            <div class="email-relevant">
              <router-link :to="{ name: 'UserRetrievePassEmail' }">
                邮箱方式
              </router-link>
            </div>
            <div class="teacher-teacher">
              <router-link :to="{ name: 'TeacherRetrievePass' }">
                <span class="color-grey">教员找回</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <account-footer />
  </div>
</template>

<script>
import { AccountHeader, AccountFooter } from '@/components'

export default {
  name: 'UserRetrievePass',
  description: '这是描述信息',
  components: {
    AccountHeader,
    AccountFooter
  },
  props: {
    change_pass_token: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      captcha_key: '',
      captcha_value: '',
      captcha_img_str: '',
      phone_available: false,
      lastTimeContent: '获取验证码',
      state: {
        retrieveBtn: false,
        getCodeBtn: false
      },
      retrieveError: false,
      retrieveErrorMessage: ''
    }
  },
  created() {
    this.loadVerify()
  },
  methods: {
    loadVerify() {
      this.$http({
        url: '/index/index/captcha',
        method: 'get'
      }).then(res => {
        if (res.status === 'success') {
          this.captcha_key = res.data.captcha_key
          this.captcha_value = res.data.captcha_value
          this.captcha_img_str = res.data.img_str
        } else {
          this.$toast.fail('获取验证码失败')
        }
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      const { form, state } = this
      this.retrieveError = false
      form.validateFields((err, values) => {
        if (!err) {
          this.state.retrieveBtn = true
          this.$http({
            url: '/index/user_account/retrievePassCheckPhoneCode',
            method: 'post',
            data: values
          })
            .then(res => {
              if (res.status === 'success') {
                this.$toast.success('验证成功，跳转密码重置页面')
                setTimeout(() => {
                  this.$router.push({
                    path: '/account/user-reset-pass',
                    query: { change_pass_token: res.data.change_pass_token }
                  })
                }, 3000)
              } else {
                this.retrieveError = true
                this.retrieveErrorMessage = res.message
              }
            })
            .finally(() => {
              state.retrieveBtn = false
            })
        }
      })
    },
    handleGetPhoneCode() {
      // 获取短信验证码
      const that = this
      this.form.validateFields(
        ['username', 'phone', 'captcha_value'],
        (err, values) => {
          if (!err) {
            values.captcha_key = this.captcha_key
            values.captcha_value = this.captcha_value
            that.state.getCodeBtn = true
            // 按钮变灰，倒计时
            new Promise((resolve, reject) => {
              this.$http({
                url: '/index/user_account/retrievePassGetPhoneCode',
                method: 'post',
                data: values
              }).then(response => {
                if (response.status === 'success') {
                  resolve(response)
                } else {
                  reject(response)
                }
              })
            })
              .then(res => {
                const data = res.data
                let lastTime = data.count_down
                const timer = setInterval(() => {
                  if (lastTime > 0) {
                    this.lastTimeContent = lastTime + 's'
                    lastTime--
                  } else {
                    window.clearInterval(timer)
                    this.lastTimeContent = '发送验证码'
                    that.state.getCodeBtn = false
                  }
                }, 1000)
                // 倒计时
              })
              .catch(error => {
                that.state.getCodeBtn = false
                // 设置错误信息到验证码输入框下
                that.form.setFields({
                  captcha_value: {
                    value: values.captcha_value,
                    errors: [new Error(error.message)]
                  }
                })
                // 刷新验证码
                that.loadVerify()
              })

            console.log(values)
          }
        }
      )
    }
  }
}
</script>
<style lang="stylus" scoped>
.base {
  min-width: 280px;
  max-width: 420px;
  margin: auto;
  background-color: #fff;
}

.main {
  padding: 15px;

  .panel {
    background-color: #ffffff;
    box-shadow: 1px 3px 16px 0px rgba(34, 23, 20, 0.1);
    border-radius: 10px;
    padding: 15px;
    overflow: hidden;
    margin-top: 15px;

    .panno {
      width: 75px;
      height: 10px;
      background-color: #fa750d;
      border-radius: 9px;
      position:relative;
      top:-18px;
      margin:auto;
    }

    .title {
      text-align: center;
      margin-top: 30px;
      font-family: PingFang-SC-Bold;
      font-size: 18px;
      line-height: 21px;
      color: #333333;
      font-weight: bold;
    }

    .form-panel {
        text-align: left;
        margin-top: 20px;

        .get-code-btn {
          position: absolute;
          right: 0;
        }
      }

    .relevant {
      width: 100%;
      height: 20px;

      .email-relevant {
        float: left;
      }

      .teacher-teacher {
        float: right;
      }
    }
  }
}
</style>
